import { UserRoles } from '../../Shared/constants/userRoles';

export const validateUserFields = (
  firstName: string,
  lastName: string,
  t: (key: string) => string,
  emailId: string,
  userRole: string,
  category: string | null = null,
  orgName: string | null = null
) => {
  const nameRegex = /^[a-zA-Z\s'-]{1,50}$/;
  // Only allow @amazon.com emails
  const emailRegex = /^[^\s@]+@amazon\.com$/;

  const roleError = !userRole.trim() ? t('user-role-required-error') : '';

  // Category is mandatory only if role is Account Executive
  const categoryError = userRole === UserRoles.ACCOUNT_EXECUTIVE && !category?.trim()
    ? t('category-required-error')
    : '';

  // OrgName is mandatory for AE role only
  const orgNameError = userRole === UserRoles.ACCOUNT_EXECUTIVE && !orgName?.trim()
    ? t('org-name-required-error')
    : '';

  return {
    firstName: !firstName.trim()
      ? t('first-name-required-error')
      : !nameRegex.test(firstName.trim())
        ? t('first-name-invalid-error')
        : '',
    lastName: !lastName.trim()
      ? t('last-name-required-error')
      : !nameRegex.test(lastName.trim())
        ? t('last-name-invalid-error')
        : '',
    emailId: !emailId.trim()
      ? t('email-id-required-error')
      : !emailRegex.test(emailId.trim())
        ? t('email-id-invalid-error')
        : '',
    userRole: roleError,
    category: categoryError,
    orgName: orgNameError,
  };
};
